module.exports = __webpack_public_path__ + "static/media/related-cases3.36f20794.jpg";